import React, { FunctionComponent } from 'react';

import ViewHeader from './ViewHeader';

const MainViewHeader: FunctionComponent = () => <ViewHeader />;

export default MainViewHeader;
